import BaseObject from '../../../../../base/base_object';
import {SYSTEM_EVENTS} from '../../../../../events/events';
import Event from '../../../../../utils/event';
import NetEntExtend from '../../../../netent/netent_extend';


interface NetEntGameEventListenerParams {
    netEntExtend: NetEntExtend;
}


export default class NetEntGameEventListener extends BaseObject {
    static CLASS = 'NetEntGameEventListener';

    _params: NetEntGameEventListenerParams;

    protected init(params: NetEntGameEventListenerParams) {
        super.init(params)
        this._params = params;

        this._subscribeToEvent('gameReady');
        this._subscribeToEvent('gameRoundStarted');
        this._subscribeToEvent('gameRoundEnded');
        this._subscribeToEvent('goToLobby');
        this._subscribeToEvent('dialogBoxClosed');

        //this._subscribeToEvent('gameError');
        //handling gameErrorClose will block receiving dialogBoxClosed when no money is left
        //this._subscribeToEvent('gameErrorClose');
    }

    private _eventSubscriptions = {};

    private _subscribeToEvent(eventName: string): void {

        if(this._eventSubscriptions[eventName]) {
            throw new Error(`You already subscribed to NetEnt event ${eventName}`);
        }

        const handler = function() {
            const argCount = arguments.length;
            let eventParams: any = {argCount: argCount};
            if (argCount <= 1) {
                eventParams = (arguments.length > 0)? arguments[0] : undefined;
            } else {
                for (let i = 0; i < argCount; i++) {
                    const key = `p${i + 1}`;
                    eventParams[key] = arguments[i];
                }
            }

            Event.fire(SYSTEM_EVENTS.POST_MESSAGE_ARRIVE, {
                data: {
                    eventName: eventName,
                    eventParams: eventParams
                }
            });
        };

        this._params.netEntExtend.addEventListener(eventName, handler);

        this._eventSubscriptions[eventName] = handler;
    }

    dispose() {
        Object.keys(this._eventSubscriptions).forEach(eventName => {
            this._params.netEntExtend.removeEventListener(eventName, this._eventSubscriptions[eventName]);
        });
    }

}